import React from 'react';
export function ReassuranceSection() {
  return <section className="py-16 px-4 bg-[#FAF7F2] border-y border-[#C9A96E]/20" data-id="element-59">
      <div className="max-w-4xl mx-auto text-center" data-id="element-60">
        <div className="inline-block mb-6" data-id="element-61">
          <div className="h-px w-20 bg-[#C9A96E] mx-auto mb-2" data-id="element-62"></div>
          <span className="text-[#C9A96E] uppercase tracking-widest text-xs font-medium" data-id="element-63">
            La Promesa
          </span>
        </div>

        <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif text-[#1C1C1C] mb-6 leading-tight" data-id="element-64">
          "No necesitas una máquina industrial.{' '}
          <br className="hidden md:block" data-id="element-65" />
          No necesitas ser una experta."
        </h2>

        <div className="max-w-2xl mx-auto" data-id="element-66">
          <p className="text-base md:text-xl text-[#1C1C1C]/70 font-light italic font-serif" data-id="element-67">
            Solo necesitas el mapa correcto.
          </p>
          <p className="mt-4 text-sm md:text-base text-[#1C1C1C]/80 leading-relaxed" data-id="element-68">
            Este no es un curso de costura aburrido para hacer manteles. Es una
            guía de ingeniería estética diseñada para transformar tu hogar con
            técnicas profesionales simplificadas.
          </p>
        </div>
      </div>
    </section>;
}